'use client';
import React, { KeyboardEvent } from 'react';

import {
  LocationIcon,
  ProfileReservation,
  UpArrowIcon,
  DownArrowIcon,
} from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import { SelectProps } from './SelectInterface';
import {
  SelectContent,
  StyledSelect,
  ToggleSelect,
  SelectIconWrapper,
  SelectTextContent,
  SelectLabel,
  SelectBoxIcon,
  SelectInput,
} from './SelectStyle';
const Select = (props: SelectProps) => {
  // ======================================
  // getting the needed props for the select
  // ======================================
  const {
    icon,
    label,
    text,
    type,
    selected = false,
    onSelect,
    isInput,
    onInputChange,
    onFocus,
    onInputBlur,
    DatePicker,
    inputRef,
    onInputKeyDown,
    className,
    renderArrow = true,
    placeholder,
  } = props;

  // ======================================
  // custom function to render the icons
  // ======================================
  const renderIcon = (name: string): React.JSX.Element => {
    switch (name) {
      case 'location-pin':
        return <CustomIcon icon={LocationIcon} fontSize={28} />;

      case 'calendar':
      default:
        return (
          <CustomIcon
            icon={ProfileReservation}
            paletteColor='black'
            fontSize={28}
          />
        );
    }
  };

  const onKeyPress = (e: KeyboardEvent): void => {
    const enterOrSpace =
      e.key === 'Enter' ||
      e.key === ' ' ||
      e.key === 'Spacebar' ||
      e.which === 13 ||
      e.which === 32;
    if (enterOrSpace) {
      e.preventDefault();
      if (onSelect) onSelect();
    }
  };
  const shouldRenderDatePicker = Boolean(DatePicker && selected);
  return (
    <StyledSelect className={className} data-testid='listing-search-select-box'>
      {isInput || DatePicker ? (
        <ToggleSelect
          className='toggle-select'
          data-testid='search-toggle-select'
          onClick={onSelect}
          onKeyPress={onKeyPress}
          role='button'
          tabIndex={-1}
        />
      ) : null}

      <SelectContent>
        <SelectIconWrapper color='tomato' size={28}>
          {renderIcon(icon)}
        </SelectIconWrapper>
        <SelectTextContent>
          <SelectLabel>{label}</SelectLabel>
          <br />
          <SelectInput
            value={text}
            ref={inputRef}
            onFocus={onFocus}
            onBlur={onInputBlur}
            onChange={onInputChange}
            placeholder={
              placeholder ??
              {
                hotel: 'Yurt İçi - Yurt Dışı, Otel Adı veya Konum',
                Tour: 'Yurt dışı turlar, Yurt içi turlar',
                Cruise: 'Ülke, şehir, bölge, liman veya tur adı',
              }[type ?? 'hotel']
            }
            onKeyDown={onInputKeyDown}
            data-testid='select-location-box-input'
          />
        </SelectTextContent>
      </SelectContent>

      {renderArrow ? (
        <SelectBoxIcon>
          <CustomIcon
            icon={!selected ? DownArrowIcon : UpArrowIcon}
            fontSize={16}
            paletteColor='darkGray'
          />
        </SelectBoxIcon>
      ) : null}
      {shouldRenderDatePicker ? DatePicker : null}
    </StyledSelect>
  );
};

export default Select;
